import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const GradientBonusActivitySubscribers: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="GradientBonusActivitySubscribers"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M47.3929 18.6348C48.7024 20.903 48.7024 23.6974 47.3929 25.9656L39.0583 40.4016C37.7487 42.6697 35.3287 44.0669 32.7096 44.0669H16.0404C13.4214 44.0669 11.0013 42.6697 9.69175 40.4016L1.35714 25.9656C0.0476209 23.6974 0.0476209 20.903 1.35714 18.6348L9.69175 4.19883C11.0013 1.93068 13.4214 0.533447 16.0404 0.533447H32.7096C35.3287 0.533447 37.7487 1.93068 39.0582 4.19883L47.3929 18.6348Z"
            fill="url(#paint0_linear_8581_29635)"
          />
          <path
            d="M43.1128 18.8362C44.1788 20.6826 44.1788 22.9575 43.1128 24.8039L36.3279 36.5556C35.2619 38.4021 33.2918 39.5395 31.1597 39.5395H17.59C15.4579 39.5395 13.4878 38.4021 12.4218 36.5556L5.63692 24.8039C4.5709 22.9575 4.5709 20.6826 5.63692 18.8362L12.4218 7.08443C13.4878 5.23802 15.4579 4.10059 17.59 4.10059H31.1597C33.2918 4.10059 35.2619 5.23802 36.3279 7.08443L43.1128 18.8362Z"
            fill="black"
          />
          <path
            d="M43.1127 20.7263C44.1787 22.5025 44.1787 24.6908 43.1127 26.4671L36.3278 37.772C35.2618 39.5482 33.2917 40.6424 31.1597 40.6424H17.5899C15.4579 40.6424 13.4878 39.5482 12.4218 37.772L5.63692 26.4671C4.5709 24.6908 4.5709 22.5025 5.63692 20.7263L12.4218 9.4213C13.4878 7.64509 15.4579 6.5509 17.5899 6.5509H31.1597C33.2917 6.5509 35.2618 7.64509 36.3278 9.4213L43.1127 20.7263Z"
            fill="url(#paint1_linear_8581_29635)"
          />
          <path
            d="M15.0146 8.5509C15.0146 7.44633 15.9101 6.5509 17.0146 6.5509H31.6763C32.7808 6.5509 33.6763 7.44633 33.6763 8.5509V31.1199C33.6763 31.9123 32.7986 32.3899 32.1332 31.9596L24.8876 27.2733C24.5571 27.0595 24.1319 27.0595 23.8014 27.2733L16.5578 31.9593C15.8925 32.3898 15.0146 31.9122 15.0146 31.1197V8.5509Z"
            fill="white"
          />
          <path
            d="M24.3457 8.99475V20.4457"
            stroke="#BF9BF1"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17.501 6.5509V27.1746C17.501 27.5645 17.9275 27.8044 18.2607 27.6018L24.1528 24.0195C24.3131 23.9221 24.5146 23.9226 24.6744 24.0209L30.4866 27.5952C30.8198 27.8 31.2485 27.5604 31.2485 27.1693V6.5509"
            stroke="#BF9BF1"
            strokeWidth="1.5"
          />
          <path
            d="M23.6819 36.2012C23.6819 36.2012 23.4567 36.1261 23.1439 36.0219C22.065 35.6623 21.2061 34.8034 20.8464 33.7245C20.7422 33.4116 20.6671 33.1864 20.6671 33.1864C20.6215 33.0498 20.4936 32.9576 20.3496 32.9576C20.2056 32.9576 20.0777 33.0498 20.0321 33.1864C20.0321 33.1864 19.957 33.4116 19.8529 33.7244C19.4932 34.8034 18.6343 35.6623 17.5554 36.0219C17.2425 36.1261 17.0173 36.2012 17.0173 36.2012C16.8807 36.2468 16.7886 36.3747 16.7886 36.5187C16.7886 36.6628 16.8807 36.7906 17.0174 36.8362C17.0174 36.8362 17.2426 36.9113 17.5553 37.0155C18.6343 37.3751 19.4932 38.234 19.8529 39.3129C19.957 39.6258 20.0321 39.851 20.0321 39.851C20.0777 39.9876 20.2056 40.0798 20.3496 40.0798C20.4936 40.0798 20.6216 39.9876 20.6671 39.851C20.6671 39.851 20.7423 39.6258 20.8464 39.313C21.2061 38.234 22.065 37.3751 23.1439 37.0155C23.4567 36.9113 23.6819 36.8362 23.6819 36.8362C23.8185 36.7906 23.9107 36.6628 23.9107 36.5187C23.9107 36.3747 23.8185 36.2468 23.6819 36.2012Z"
            fill="white"
          />
          <path
            d="M31.7322 36.2012C31.7322 36.2012 31.507 36.1261 31.1942 36.0219C30.1153 35.6623 29.2563 34.8034 28.8967 33.7245C28.7925 33.4116 28.7174 33.1864 28.7174 33.1864C28.6718 33.0498 28.5439 32.9576 28.3999 32.9576C28.2559 32.9576 28.128 33.0498 28.0824 33.1864C28.0824 33.1864 28.0073 33.4116 27.9032 33.7244C27.5435 34.8034 26.6846 35.6623 25.6057 36.0219C25.2928 36.1261 25.0676 36.2012 25.0676 36.2012C24.931 36.2468 24.8389 36.3747 24.8389 36.5187C24.8389 36.6628 24.931 36.7906 25.0677 36.8362C25.0677 36.8362 25.2929 36.9113 25.6056 37.0155C26.6846 37.3751 27.5435 38.234 27.9031 39.3129C28.0073 39.6258 28.0824 39.851 28.0824 39.851C28.128 39.9876 28.2559 40.0798 28.3999 40.0798C28.5439 40.0798 28.6719 39.9876 28.7174 39.851C28.7174 39.851 28.7926 39.6258 28.8967 39.313C29.2564 38.234 30.1153 37.3751 31.1942 37.0155C31.507 36.9113 31.7322 36.8362 31.7322 36.8362C31.8688 36.7906 31.961 36.6628 31.961 36.5187C31.961 36.3747 31.8688 36.2468 31.7322 36.2012Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8581_29635"
              x1="24.375"
              y1="0.533447"
              x2="24.375"
              y2="44.0669"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.48" stopColor="#9982FF" />
              <stop offset="0.945" stopColor="#F0B571" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8581_29635"
              x1="24.3748"
              y1="6.5509"
              x2="24.3748"
              y2="40.6424"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.45" stopColor="#9982FF" />
              <stop offset="1" stopColor="#F0B571" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default GradientBonusActivitySubscribers;
